import React, { useState } from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { Icon, SVGComponent } from '../../partials/icon/Icon';
import { AdditionalStyleSheet } from '../../components.utils';
import { useTheme } from '../../../theming/useTheme';

const componentConfigThemeKey = 'socialButtons';

interface SocialButtonsThemeProps {
  backgroundColor: string;
  strokeColor: string;
}

interface SocialButtonData {
  name: string;
  icon: SVGComponent;
  onClick: () => void;
}

interface SocialButtonsProps {
  socialButtons: SocialButtonData[];
}

const getSocialButtonsStyle = (backgroundColor: string, strokeColor: string) => StyleSheet.create({
  wrapper: {
    display: 'flex',
    gap: '15px',
  },
  circle: {
    height: '36px',
    width: '36px',
    border: `2px solid ${strokeColor}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    cursor: 'pointer',
    backgroundColor,
    ':hover': {
      backgroundColor: strokeColor,
    },
  },
});

const getIconStyle = (isHover: boolean, backgroundColor: string, strokeColor: string) => StyleSheet.create({
  svg: {
    fill: isHover ? backgroundColor : strokeColor,
  },
});

export const SocialButtons: React.FunctionComponent<SocialButtonsProps> = props => {
  const { socialButtons } = props;
  const [hoverButton, setHoverButton] = useState('');

  const {
    backgroundColor,
    strokeColor,
  } = useTheme<SocialButtonsThemeProps>(componentConfigThemeKey);

  const styles = getSocialButtonsStyle(backgroundColor, strokeColor);
  return (
    <div className={css(styles.wrapper)}>
      {socialButtons.map(button => {
        const { name, icon, onClick } = button;
        const iconStyles = getIconStyle(hoverButton === name, backgroundColor, strokeColor).svg as AdditionalStyleSheet;
        return (
          <div
            key={name}
            className={css(styles.circle)}
            onClick={onClick}
            onMouseEnter={() => setHoverButton(name)}
            onMouseLeave={() => setHoverButton('')}
          >
            <Icon icon={icon} additionalStyle={iconStyles} />
          </div>
        );
      })}
    </div>
  );
};
